/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import ExpressPetQualifiesCard from "./ExpressPetQualifiesCard";
import ReasonForVisitCardList from "./ReasonForVisitCardList";
import { useReasonForVisitV2 } from "../../../services/reason-for-visitV2/reason-for-visit.service-v2";
import { useExpressNotificationsStore } from
  "../../../hooks/redux-hooks/express-notifications-store/express-notifications-store";
import { IExpressNotificationListItem } from "../../../state/express-notifications/express-notifications.reducer";
import { CentralLoadingIndicator } from "../../../components";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { IPetDetail } from "../../../components/PetAvatars/PetAvatars";
import { useCombinedAlertsDataStore } from "../../../hooks";
import { markExpressEligibilityPets } from "../../../components/DrawerGeneric/DrawerGeneric";

const ExpressServiceAvailableModal = () => {
  const { closeModal } = useModal();
  const { user } = useUserDetail();
  const { expressReasonList, loading } = useReasonForVisitV2();
  const [eligiblePetsList, setEligiblePetsList] = useState<IPetDetail[]>([]);
  // const { setExpressNotificationList } = useExpressNotificationsStore();
  const { isExpressEligible } = useCombinedAlertsDataStore();

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toLocaleUpperCase() + string.substring(1);
  };


  const formatPetNames = (petNames: string[]): string => {
    if (!petNames || petNames.length === 0) return "";

    const capitalizedNames = petNames.map(capitalizeFirstLetter);

    if (capitalizedNames.length === 1) {
      return capitalizedNames[0];
    }

    if (capitalizedNames.length === 2) {
      return capitalizedNames.join(" and ");
    }

    if (capitalizedNames.length === 3) {
      return `${capitalizedNames.slice(0, -1).join(", ")} and ${capitalizedNames[2]}`;
    }

    return `${capitalizedNames.slice(0, 3).join(", ")} & ${capitalizedNames.length - 3} more`;
  };

  const handleCloseModal = ()=>{
    // setExpressNotificationList([]);
    markExpressEligibilityPets(isExpressEligible.map((pet: any)=> pet?.petName));
    closeModal();
  };

  useEffect(()=>{
    if (isExpressEligible.length) {
      const eligiblePets = isExpressEligible.map((pet: any)=>({ name: pet.petName, image: pet.imageUrl }));

      eligiblePets && setEligiblePetsList(eligiblePets);
    } else {
      closeModal();
    }
  }, [isExpressEligible]);

  return (
    <div className="h-full flex flex-col justify-between px-3">
      <div className="w-full flex justify-end">
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className={`h-full flex flex-col gap-2 items-center
      justify-between min-h-0 max-h-86 scrollbar-thin ${!loading?" overflow-y-auto":""}`}>
        {eligiblePetsList.length > 0 &&
        <ExpressPetQualifiesCard
          petsName={formatPetNames(eligiblePetsList.map((pet)=>(pet.name)))}
          locationName={`Goodvets ${user?.location?.locationName}`}
          eligiblePetsList = { eligiblePetsList }
        />}
        <div className="text-center text-sm font-semibold px-9">
          Book an Express Services appointment for these fast and routine services for{" "}
          <span>
            {formatPetNames(eligiblePetsList.map((pet)=>(pet.name)))}
          </span>
        </div>
        <div className="w-full">
          {loading?
            <CentralLoadingIndicator />:
            <ReasonForVisitCardList reasonsList={expressReasonList.flatMap((category) => category.options)} />}
        </div>
      </div>
      <div className="flex flex-col gap-4 pb-1 pt-1.5">
        <StyledBookingFlowButton
          color="primary"
          disabled={false} // add disable conditions if any
          size="small"
          className="w-full"
          onClick={handleCloseModal}
        >
            Got it, Thanks!
        </StyledBookingFlowButton>
        <div className="text-xs text-center text-light-black">
            *Express Services are only available at hospitals where you have established care.
            If you switch locations, you may lose access to express services.
        </div>
      </div>
    </div>
  );
};

export default ExpressServiceAvailableModal;
